export const environment = {
  production: false,
  apiBaseUrl: 'https://lisa-development.integration.libri.cloud',
  bibliografieBaseUrl: 'https://bibliografie-development.integration.libri.cloud',
  keycloak: {
    url: 'https://lisa-development.integration.libri.cloud/auth',
    realm: 'lisa',
    clientId: 'lisa-client'
  },
  controlCenter: {
    apiUrl: 'https://control-center-development.quimus-labs.app',
    environmentName: 'development'
  }
};
